export default __webpack_public_path__ + "static/media/home_black_24dp (1).e957d89c.svg";